
export type MenuButtonBaseProps = {
    id: string
    onClick: () => void
    title: string
    className?: string
    children: React.ReactNode
}

const MenuButtonBase = (props: MenuButtonBaseProps) => {
    const css = props.className ? props.className : ''

    return <button id={props.id} type='button'
            onClick={() => {props.onClick()}}
            title={props.title}
            className={`menu-item ${css}`}>
            {props.children}
        </button>
}

export default MenuButtonBase